import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import { resolveEffectiveLanguage, applyDocumentLanguage } from "../utils/languageRegistry";

export function handleLanguageDirection(lang: string) {
  applyDocumentLanguage(lang);
}

// Resolve initial language from URL route, saved preference, or browser auto detection
const initialLanguage = typeof window !== "undefined"
  ? resolveEffectiveLanguage(window.location.pathname)
  : "en";

// Initialize i18next
i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    fallbackLng: "en",
    defaultNS: "common",
    ns: [
      "common",
      "nav",
      "search",
      "pipeline",
      "analytics",
      "settings",
      "pricing",
      "safety",
      "footer",
      "jobs",
      "campaigns",
      "admin",
    ],
    fallbackNS: [
      "common",
      "nav",
      "search",
      "pipeline",
      "analytics",
      "settings",
      "pricing",
      "safety",
      "footer",
      "admin",
      "jobs",
      "campaigns",
    ],
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json?v=" + Date.now(),
    },
    interpolation: {
      escapeValue: false, // React already safe from XSS
    },
    react: {
      useSuspense: false, // Prevent hydration issues
    },
  });

// Apply initial direction
handleLanguageDirection(initialLanguage);

// In development mode, log missing keys to console
if (process.env.NODE_ENV !== "production") {
  i18n.on("missingKey", (lngs, namespace, key) => {
    console.warn(`⚠️ [i18n] Missing translation key "${key}" in namespace "${namespace}" for languages:`, lngs);
  });
}

// Synchronize document attributes on language change
i18n.on("languageChanged", (lng) => {
  handleLanguageDirection(lng || "en");
  if (typeof localStorage !== "undefined") {
    localStorage.setItem("biznearyou_locale", lng || "en");
  }
});

export default i18n;
